import { create } from 'zustand';
import i18n from 'i18n';
import { ApiUtils, AuthApi } from '@shared/api';
import { AuthUtils } from '@shared/utils';
import type { BaseReturn } from '@shared/types';

interface UseLogoutStore {
  loading: boolean;
  data: boolean | null;
  error?: string | null;
  logout: () => Promise<BaseReturn<boolean | null>>;
  clear: () => void;
}

export const useLogoutStore = create<UseLogoutStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  logout: async () => {
    try {
      set({ loading: true, data: null, error: null });
      await AuthApi.logout();
      AuthUtils.logout();
      set({ loading: false, data: true });
      return { loading: false, data: true };
    } catch (e) {
      AuthUtils.logout();
      const error = i18n.t(`errors.api.${ApiUtils.getError(e)}`, ApiUtils.getError(e));
      set({ loading: false, data: false, error });
      return { loading: false, data: false, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
